// extracted by mini-css-extract-plugin
module.exports = {"causeDetails":"CauseDetailsSection_causeDetails__lmA2r","charityList":"CauseDetailsSection_charityList__FrSJm"};